<script setup>

</script>

<template>
  <div>
    <h1>Dashboard 123</h1>
  </div>
</template>
